import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer.js'
import Slider from "react-slick"
import ProductTabs from '../../components/ProductTabs'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';

const QuickLimePage = () => {

    const productData = {
        description: [
            "Quick Lime, also known as Calcium Oxide (CaO), is a highly reactive alkaline compound produced by thermal decomposition of limestone at high temperatures. It is a crucial industrial chemical used in steel manufacturing, construction, water treatment, and chemical processing.",
            "Available in lump, granular, and powder forms with high calcium content and consistent reactivity for diverse industrial applications.",
            "• Bags: typically 25 kg or 50 kg multi-wall paper bags with moisture-resistant liner — suitable for construction and moderate industrial use.",
            "• Jumbo bags (FIBC): 500 kg to 1000 kg bulk bags with moisture barrier for large-scale operations and efficient material handling.",
            "• Bulk delivery: available in bulk tankers, tipper trucks, or pneumatic systems for high-volume industrial requirements.",
            "• Silos and hoppers: for on-site storage with controlled dispensing systems to maintain product quality and reactivity.",
            "• Packing & labeling: all packages supplied with technical specifications, safety data sheets (SDS), and handling guidelines. Moisture-proof packaging is critical to prevent premature hydration and maintain product effectiveness."
        ],
        applications: [
            {
                id: 1,
                title: "Steel & Metallurgical Industry",
                description: "Quick Lime is essential in steel production for removing impurities, desulfurization, and slag formation. Used in blast furnaces, basic oxygen furnaces (BOF), and electric arc furnaces (EAF) for refining molten metal.",
                image: "/images/products/quick-lime/steel.jpg"
            },
            {
                id: 2,
                title: "Construction & Soil Stabilization",
                description: "Used in road construction, soil stabilization, and ground improvement projects. Quick Lime reacts with clay soils to improve load-bearing capacity, reduce plasticity, and enhance construction site conditions.",
                image: "/images/products/quick-lime/soil.jpg"
            },
            {
                id: 3,
                title: "Water & Wastewater Treatment",
                description: "Applied for pH adjustment, water softening, and neutralization of acidic wastewater. Quick Lime is effective in removing heavy metals, phosphates, and organic contaminants from industrial and municipal water systems.",
                image: "/images/products/quick-lime/water.jpg"
            },
            {
                id: 4,
                title: "Chemical Manufacturing & Industrial Processes",
                description: "Key raw material for producing calcium-based chemicals, calcium carbide, precipitated calcium carbonate (PCC), and various industrial compounds. Used in paper manufacturing, sugar refining, and environmental applications.",
                image: "/images/products/quick-lime/chemical.jpg"
            }
        ]
    };

    return (
        <Fragment>
            <SEO title={seoData.quickLime.title} description={seoData.quickLime.description} keywords={seoData.quickLime.keywords} />
            <Navbar/>
            <PageTitle pageTitle="Quick Lime" pagesub="Quick Lime" parentPage="Products" parentLink="#" />
            <div className="team-pg-area product-page-section">
                <div className="container">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <Slider dots={true} arrows={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={3000}>
                                        <div className="image-box">
                                            <img src='/images/products/quick-lime/ql1.jpg' alt="Quick Lime" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/quick-lime/ql2.jpg' alt="Quick Lime Lumps" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/quick-lime/ql3.jpg' alt="Quick Lime Packaging" />
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2>Quick Lime (CaO)</h2>
                                    <ul>
                                        <li>Chemical Formula: <span>CaO</span></li>
                                        <li>Purity: <span>85-95%</span></li>
                                        <li>Form: <span>Lumps, Granules, Powder</span></li>
                                        <li>Packaging: <span>25kg, 50kg Bags, Bulk</span></li>
                                        <li>CAS Number: <span>1305-78-8</span></li>
                                        <li>Molecular Weight: <span>56.08 g/mol</span></li>
                                        <li>Reactivity: <span>Highly Reactive</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProductTabs product={productData} />
                </div>
            </div>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default QuickLimePage;
